module.exports = __webpack_public_path__ + "static/modinfinity-light-5773ddf6e362af5751b56d4cbf13e1ba.svg";